console.log(`Excel365 (${STAGE}) has started initializing`);

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'src/app';
import office from 'src/services/office';
import { reflect } from 'shared/utils/utils';
import { userStore } from 'src/stores';

Office.initialize = function () {};

Office.onReady(async function(result) {
  userStore.initialize();
  const { error } = await reflect(userStore.tryToSignInWithToken())

  const node = document.createElement('div');
  node.className = 'height-100';

  document.body.replaceChild(node, document.getElementById('app'));
  console.log(`Office is ready. Host: ${result.host}, platform: ${result.platform}`);

  office.platformType = result.platform;
  ReactDOM.render(<App officeStatus={result} initializeError={error} />, node);
});
